import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeadlineSharedComponent } from './headline.component';

import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        HeadlineSharedComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        IconSharedModule
    ],
    exports: [
        HeadlineSharedComponent
    ]
})

export class HeadlineSharedModule {}
